import React, { useEffect, useRef } from "react"
import { Modal } from "components"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { useLocation } from "react-router-dom"
import { FaCheckCircle } from "react-icons/fa"

import classes from "./KioskFoodSuccessModal.module.scss"

const KioskFoodSuccessModal = props => {
  const { showSuccessModal, setShowSuccessModal } = props

  const [t] = useTranslation()

  const timeout = useRef()

  const history = useHistory()

  const location = useLocation()

  const handleExit = () => {
    clearTimeout(timeout.current)
  }

  const handleEnter = () => {
    timeout.current =
      setTimeout(() => {
        setShowSuccessModal(false)

        !!location.key ? history.goBack() : history.push("/kiosk-foods")
      }, 2000)
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeout.current)
    }
  }, [])

  return (
    <Modal
      show={showSuccessModal}
      backdrop="static"
      onExited={handleExit}
      onEnter={handleEnter}

    >
      <div className={classes["container"]}>
        <FaCheckCircle
          size={60}
          color="var(--color-success)"
        />

        <h4 className={classes["title"]}>
          {t("آیتم_با_موفقیت_به_سبد_خرید_اضافه_شد")}.
        </h4>
      </div>
    </Modal>
  )
}

export default KioskFoodSuccessModal